// extracted by mini-css-extract-plugin
export default {"root":"LoginPage_root__sc352","title":"LoginPage_title__uhZXj","buttonsContainer":"LoginPage_buttonsContainer__utAPf","logoContainer":"LoginPage_logoContainer__k+A6F"};